module.exports = __webpack_public_path__ + "img/color_block_9.f1f31ab2.svg";